/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_TimezoneInputs */

const en_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Central Time`)
};

const es_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hora central`)
};

const de_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US-Zentralzeit (CT)`)
};

const zh_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中部时间`)
};

const ar_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التوقيت المركزي`)
};

const fr_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure centrale`)
};

const vi_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`giờ miền Trung Hoa Kỳ (CT)`)
};

const sw_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wakati wa Kati`)
};

const th_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลาภาคกลางของสหรัฐฯ (CT)`)
};

const bs_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centralno vrijeme`)
};

const ja_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セントラルタイム`)
};

const ko_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중부 시간`)
};

const pt_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora Central`)
};

const it_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ora centrale USA (CT)`)
};

const sv_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centraltid`)
};

const nl_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amerikaanse centrale tijd (CT)`)
};

const da_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Central tid`)
};

const nb_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentraltid`)
};

const fi_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhdysvaltain keskinen aika (CT)`)
};

const pl_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czas środkowy`)
};

const ru_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центральное время`)
};

const tr_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ABD Merkezi Saati`)
};

const hi_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केन्द्रीय समय`)
};

const id_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu Tengah AS (CT)`)
};

const ms_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu Tengah AS (CT)`)
};

const cs_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centrální čas`)
};

const el_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κεντρική ώρα`)
};

const he_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שעון מרכז ארה״ב (CT)`)
};

const af_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentrale tyd (CT)`)
};

const hu_booking_timezone = /** @type {(inputs: Booking_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Központi idő`)
};

/**
* | output |
* | --- |
* | "Central Time" |
*
* @param {Booking_TimezoneInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_timezone = /** @type {((inputs?: Booking_TimezoneInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_TimezoneInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_timezone(inputs)
	if (locale === "de") return de_booking_timezone(inputs)
	if (locale === "zh") return zh_booking_timezone(inputs)
	if (locale === "ar") return ar_booking_timezone(inputs)
	if (locale === "fr") return fr_booking_timezone(inputs)
	if (locale === "vi") return vi_booking_timezone(inputs)
	if (locale === "sw") return sw_booking_timezone(inputs)
	if (locale === "th") return th_booking_timezone(inputs)
	if (locale === "bs") return bs_booking_timezone(inputs)
	if (locale === "ja") return ja_booking_timezone(inputs)
	if (locale === "ko") return ko_booking_timezone(inputs)
	if (locale === "pt") return pt_booking_timezone(inputs)
	if (locale === "it") return it_booking_timezone(inputs)
	if (locale === "sv") return sv_booking_timezone(inputs)
	if (locale === "nl") return nl_booking_timezone(inputs)
	if (locale === "da") return da_booking_timezone(inputs)
	if (locale === "nb") return nb_booking_timezone(inputs)
	if (locale === "fi") return fi_booking_timezone(inputs)
	if (locale === "pl") return pl_booking_timezone(inputs)
	if (locale === "ru") return ru_booking_timezone(inputs)
	if (locale === "tr") return tr_booking_timezone(inputs)
	if (locale === "hi") return hi_booking_timezone(inputs)
	if (locale === "id") return id_booking_timezone(inputs)
	if (locale === "ms") return ms_booking_timezone(inputs)
	if (locale === "cs") return cs_booking_timezone(inputs)
	if (locale === "el") return el_booking_timezone(inputs)
	if (locale === "he") return he_booking_timezone(inputs)
	if (locale === "af") return af_booking_timezone(inputs)
	if (locale === "hu") return hu_booking_timezone(inputs)
	return en_booking_timezone(inputs)
});